/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineIdsViewModel } from "../types/ClassroomDisciplineIdsViewModel.ts";

export const classroomDisciplineIdsViewModelSchema = z.object({
  classroomDisciplineIds: z.array(z.number().int()).nullish(),
}) as unknown as ToZod<ClassroomDisciplineIdsViewModel>;
